/*
 * Copyright © 2018, Rezo Zero
 *
 * @file TextBlock.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 */

import { AbstractBlock } from 'starting-blocks'
import * as Utils from '../utils/Utils'

export default class TextBlock extends AbstractBlock {
    init () {
        super.init()

        if (this.page.context === 'static') {
            this.simpleTextAnimations()
        }
    }

    initEvents () {
        super.initEvents()
    }

    destroyEvents () {
        super.destroyEvents()
    }

    simpleTextAnimations () {
        if (Utils.isMobile()) {
            this.$cont[0].classList.add('visible')
            return
        }

        const paragraphs = [...this.$cont.find('p')]
        const descriptionSplitText = new window.SplitText(paragraphs, { type: 'lines' })

        /**
         * @type {Array<HTMLElement>}
         */
        const lines = descriptionSplitText.lines

        for (let line of lines) {
            line.classList.add('js-animate')
            line.classList.add('in-view')
            line.setAttribute('data-manual-offset', '0')
        }

        window.setTimeout(() => (
            this.$cont[0].classList.add('visible')
        ), 300)
    }

    onLoad () {
        super.onLoad()
    }

    onResize () {
        super.onResize()
    }

    onPageReady () {
        super.onPageReady()
    }

    onTransitionComplete () {
        this.simpleTextAnimations()
    }
}



// WEBPACK FOOTER //
// ./webpack/js/blocks/TextBlock.js